'use client';
import React, { Component } from 'react';
import { ContentManager, DentalInsurancePlan } from '@benzinga/content-manager';
import styled from '@benzinga/themetron';
import { getSessionSingleton } from '@benzinga/session';
import { PatternFormat } from 'react-number-format';
import { BirthdayField } from '../DentalInsurance/BirthdayField';
import { UserMetaField } from '../DentalInsurance/UserMetaField';
import { GenderField } from '../DentalInsurance/GenderField';
import { InsurancePlans } from '../DentalInsurance/InsurancePlans';
import { Icon, Button } from '@benzinga/core-ui';
import { faTimes as times } from '@fortawesome/pro-regular-svg-icons/faTimes';
import dayjs from 'dayjs';

interface Props {
  attrs: any;
  error: string[];
  isLoading: boolean;
  items: string[];
  plansList: DentalInsurancePlan[];
  quoteRequestId: string;
  zipCode: string;
  First_Name: string;
  Last_Name: string;
  Email_Address: string;
  Cell_Phone: string;
  addSpouse: boolean;
  dental_insurance: {
    main_applicant: Applicant;
    relation_spouse: Applicant;
    relation_child: object;
  };
}

interface Applicant {
  error?: string[];
  familyRelationship?: number;
  gender?: string;
  birthdate?: string;
  isSmoker?: boolean;
  isStudent?: boolean;
  isDisabled?: boolean;
  haveSmoker?: boolean;
  haveStudent?: boolean;
  haveDisabled?: boolean;
  haveGender?: boolean;
  heading?: string;
}

interface State {
  attrs: any;
  error: string[];
  isLoading: boolean;
  items: any[];
  plansList: DentalInsurancePlan[];
  quoteRequestId: string;
  zipCode: string;
  First_Name: string;
  Last_Name: string;
  Email_Address: string;
  Cell_Phone: string;
  addSpouse: boolean;
  dental_insurance: {
    main_applicant: Applicant;
    relation_spouse: Applicant;
    relation_child: object;
  };
}

const getContentManager = () => getSessionSingleton().getManager(ContentManager);

export class DentalInsuranceBlock extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    props = this.state = {
      Cell_Phone: '',
      Email_Address: '',
      First_Name: '',
      Last_Name: '',
      addSpouse: false,
      attrs: '',
      dental_insurance: {
        main_applicant: {
          birthdate: '',
          familyRelationship: 0,
          gender: '1',
          haveDisabled: true,
          haveGender: true,
          haveSmoker: true,
          haveStudent: true,
          heading: 'Main applicant',
          isDisabled: false,
          isSmoker: false,
          isStudent: false,
        },
        relation_child: {},
        relation_spouse: {
          birthdate: '',
          familyRelationship: 1,
          gender: '0',
          haveDisabled: true,
          haveGender: true,
          haveSmoker: true,
          haveStudent: true,
          heading: 'Spouse',
          isDisabled: false,
          isSmoker: false,
          isStudent: false,
        },
      },
      error: [],
      isLoading: false,
      items: [],
      plansList: [],
      quoteRequestId: '',
      zipCode: '',
    };
  }

  //helper functions start
  setBirthday(bday, applicant, index = 0) {
    const birthdate = this.state.dental_insurance;
    const selectedDate = new Date(bday).toLocaleDateString();
    if (applicant == 'main') {
      birthdate.main_applicant.birthdate = selectedDate;
    } else if (applicant == 'spouse') {
      birthdate.relation_spouse.birthdate = selectedDate;
    } else {
      this.handleDisabledChildrenValidation('isDisabled', birthdate.relation_child[index].isDisabled, selectedDate);

      birthdate.relation_child[index].birthdate = selectedDate;
    }
    this.setState({ dental_insurance: birthdate });
  }

  handleDisabledChildrenValidation(field, disableStatus, bday) {
    if (field == 'isDisabled') {
      const childbday = bday;
      const date1 = dayjs();
      const diff = date1.diff(childbday, 'year');
      if (diff > 25 && disableStatus === false) {
        this.setState({ error: ['Only disabled children are allowed who are over 25 years old'] });
      } else {
        this.setState({ error: [] });
      }
    }
  }

  handleCheckBoxFields(e, applicant, field = 'isSmoker') {
    const insuranceDetail = this.state.dental_insurance;
    if (applicant == 'main') {
      insuranceDetail.main_applicant[field] = !!e.target.checked;
    } else if (applicant == 'spouse') {
      insuranceDetail.relation_spouse[field] = !!e.target.checked;
    } else {
      const fid = 1 * Number(e.target.getAttribute('data-fieldid'));
      const bday = insuranceDetail.relation_child[fid].birthdate;
      const status = !!e.target.checked;
      this.handleDisabledChildrenValidation(field, status, bday);
      insuranceDetail.relation_child[fid][field] = status;
    }
    this.setState({ dental_insurance: insuranceDetail });
  }
  handleGenderChange(e, applicant, index = 0) {
    const insuranceDetail = this.state.dental_insurance;
    if (applicant == 'main') {
      insuranceDetail.main_applicant.gender = e.target.value;
    } else if (applicant == 'spouse') {
      insuranceDetail.relation_spouse.gender = e.target.value;
    } else {
      insuranceDetail.relation_child[index].gender = e.target.value;
    }
    this.setState({ dental_insurance: insuranceDetail });
  }
  //helper functions end

  submitDentalApplication(e) {
    if (this.state.error.length > 0) {
      return;
    }
    e.preventDefault();
    this.setState({ isLoading: true });
    getContentManager()
      .saveDentalInsuranceLead({
        Cell_Phone: this.state.Cell_Phone,
        Email_Address: this.state.Email_Address,
        First_Name: this.state.First_Name,
        Last_Name: this.state.Last_Name,
        Zip_Code: this.state.zipCode,
        main_applicant: this.state.dental_insurance.main_applicant,
        relation_child: this.state.dental_insurance.relation_child,
        relation_spouse: this.state.dental_insurance.relation_spouse,
      })
      .then(res => {
        this.setState({ isLoading: false });
        if (res.ok) {
          const { plans, requestId, status } = res.ok;
          if (status === 'success') {
            this.setState({ plansList: plans });
            this.setState({ quoteRequestId: requestId });
          }
        } else {
          console.log('Something went wrong');
        }
      })
      .catch(err => {
        this.setState({ isLoading: false });
        console.log('Something went wrong');
        console.log(err);
      });
  }

  mainApplicant() {
    return (
      <div className="dental-repeater-wrapper clearfix">
        <div className="dental-repeater-item-top clearfix">
          <div className="dental-repeater-item odd">
            <label>
              Zip Code<sup className="dent-required-field">*</sup>
            </label>
            <div className="input-group">
              <input
                className="input-group-field zip-code"
                onChange={e => {
                  this.setState({ zipCode: e.target.value });
                }}
                placeholder="Enter Zip Code"
                required
                type="text"
                value={this.state.zipCode}
              />
            </div>
          </div>

          <div className="dental-repeater-item main-applicant-field even relative">
            <BirthdayField
              birthDate={this.state?.dental_insurance?.main_applicant?.birthdate ?? ''}
              setBirthdate={bday => this.setBirthday(bday, 'main')}
            />
          </div>

          <div className="dental-repeater-item odd">
            <label>
              First Name<sup className="dent-required-field">*</sup>
            </label>
            <div className="input-group">
              <input
                className="input-group-field first-name"
                onChange={e => {
                  this.setState({ First_Name: e.target.value });
                }}
                placeholder="Enter First Name"
                required
                type="text"
                value={this.state.First_Name}
              />
            </div>
          </div>
          <div className="dental-repeater-item even">
            <label>
              Last Name<sup className="dent-required-field">*</sup>
            </label>
            <div className="input-group">
              <input
                className="input-group-field last-name"
                onChange={e => {
                  this.setState({ Last_Name: e.target.value });
                }}
                placeholder="Enter Last Name"
                required
                type="text"
                value={this.state.Last_Name}
              />
            </div>
          </div>
          <div className="dental-repeater-item odd">
            <label>
              Email Address<sup className="dent-required-field">*</sup>
            </label>
            <div className="input-group">
              <input
                className="input-group-field email"
                onChange={e => {
                  this.setState({ Email_Address: e.target.value });
                }}
                placeholder="Enter Email_Address"
                required
                type="email"
                value={this.state.Email_Address}
              />
            </div>
          </div>

          <div className="dental-repeater-item even">
            <label>
              Phone<sup className="dent-required-field">*</sup>
            </label>
            <div className="input-group">
              <PatternFormat
                className="input-group-field phone"
                format="+1 (###) ###-####"
                name="phone"
                onChange={e => {
                  this.setState({ Cell_Phone: e.target.value });
                }}
              />
            </div>
          </div>

          {this.state.dental_insurance.main_applicant.haveGender && (
            <GenderField
              applicant="main"
              index="main_gender"
              setGender={(e, applicant, index) => this.handleGenderChange(e, applicant, index)}
            />
          )}

          <div className="dental-repeater-item-bottom clearfix">
            {this.state.dental_insurance.main_applicant.haveSmoker && (
              <UserMetaField
                applicant="main"
                fieldKey="isSmoker"
                handleCheckBoxFields={e => this.handleCheckBoxFields(e, 'main', 'isSmoker')}
                id="main_is_smoker"
                index={0}
                label="Is Smoker"
              />
            )}

            {this.state.dental_insurance.main_applicant.haveStudent && (
              <UserMetaField
                applicant="main"
                fieldKey="isStudent"
                handleCheckBoxFields={e => this.handleCheckBoxFields(e, 'main', 'isStudent')}
                id="main_is_student"
                index={0}
                label="Is Student"
              />
            )}

            {this.state.dental_insurance.main_applicant.haveDisabled && (
              <UserMetaField
                applicant="main"
                fieldKey="isDisabled"
                handleCheckBoxFields={e => this.handleCheckBoxFields(e, 'main', 'isDisabled')}
                id="main_is_disabled"
                index={0}
                label="Is Disabled"
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  addChild(e) {
    e.preventDefault();

    const dentalIn = { ...this.state.dental_insurance };
    let dent_len = 0;
    if (Object.keys(dentalIn.relation_child).length > 0) {
      dent_len = 1 * Number(Object.keys(dentalIn.relation_child).pop());
      dent_len++;
    }
    dentalIn.relation_child[dent_len] = {
      birthdate: '',
      familyRelationship: 2,
      gender: '0',
      haveDisabled: true,
      haveGender: true,
      haveSmoker: true,
      haveStudent: true,
      heading: 'Children',
      isDisabled: false,
      isSmoker: false,
      isStudent: false,
    };
    this.setState({ dental_insurance: dentalIn });
    this.setState(prevState => ({ items: [...prevState.items, dent_len] }));
  }

  addSpouse(e) {
    e.preventDefault();
    this.setState({ addSpouse: true });
  }

  removeDentalChild(index) {
    const i = 1 * index;
    const items = [...this.state.items];
    items.splice(i, 1);
    this.setState({ items });

    const dentalIn = { ...this.state.dental_insurance.relation_child };
    const newDental = {};
    Object.keys(dentalIn).map(child_index => {
      const onj_index = 1 * Number(child_index);
      if (onj_index !== i) {
        newDental[onj_index] = dentalIn[onj_index];
      }
    });
    const finalDental = { ...this.state.dental_insurance };
    finalDental.relation_child = newDental;
    this.setState({ dental_insurance: finalDental });
  }

  spouseApplicant() {
    return (
      <div className="dental-repeater-wrapper clearfix">
        <span
          className="dental-family-remove"
          onClick={() => {
            const defaultSpouse = this.state.dental_insurance;
            defaultSpouse.relation_spouse = {
              birthdate: '',
              familyRelationship: 1,
              gender: '0',
              haveDisabled: true,
              haveGender: true,
              haveSmoker: true,
              haveStudent: true,
              heading: 'Spouse',
              isDisabled: false,
              isSmoker: false,
              isStudent: false,
            };
            this.setState({ dental_insurance: defaultSpouse });
            this.setState({ addSpouse: false });
          }}
        >
          <Icon icon={times} />
        </span>
        <h6 className="dental-insu-heading">{this.state.dental_insurance.relation_spouse.heading}</h6>
        <div className="dental-repeater-item-top clearfix">
          <div className="dental-repeater-item odd relative">
            <BirthdayField
              birthDate={this.state?.dental_insurance?.relation_spouse?.birthdate ?? ''}
              setBirthdate={bday => this.setBirthday(bday, 'spouse')}
            />
          </div>
          {this.state.dental_insurance.relation_spouse.haveGender && (
            <GenderField
              applicant="spouse"
              index="spouse_gender"
              setGender={(e, applicant, index) => this.handleGenderChange(e, applicant, index)}
            />
          )}
        </div>
        <div className="dental-repeater-item-bottom clearfix">
          {this.state.dental_insurance.relation_spouse.haveSmoker && (
            <UserMetaField
              applicant="spouse"
              fieldKey="isSmoker"
              handleCheckBoxFields={e => this.handleCheckBoxFields(e, 'spouse', 'isSmoker')}
              id="spouse_is_smoker"
              index={0}
              label="Is Smoker"
            />
          )}
          {this.state.dental_insurance.relation_spouse.haveStudent && (
            <UserMetaField
              applicant="spouse"
              fieldKey="isStudent"
              handleCheckBoxFields={e => this.handleCheckBoxFields(e, 'spouse', 'isStudent')}
              id="spouse_is_student"
              index={0}
              label="Is Student"
            />
          )}
          {this.state.dental_insurance.relation_spouse.haveDisabled && (
            <UserMetaField
              applicant="spouse"
              fieldKey="isDisabled"
              handleCheckBoxFields={e => this.handleCheckBoxFields(e, 'spouse', 'isDisabled')}
              id="spouse_is_disabled"
              index={0}
              label="Is Disabled"
            />
          )}
        </div>
      </div>
    );
  }

  createUI() {
    const dentalIn = { ...this.state.dental_insurance.relation_child };
    return Object.keys(dentalIn).map(i => (
      <div className="dental-repeater-wrapper clearfix" key={i.toString()}>
        <span className="dental-family-remove" onClick={this.removeDentalChild.bind(this, i)}>
          <Icon icon={times} />
        </span>

        <h6 className="dental-insu-heading">{dentalIn[i].heading}</h6>
        <div className={dentalIn[i].haveGender ? 'dental-repeater-item-top clearfix' : 'dental-repeater-item-top'}>
          <div className="dental-repeater-item odd relative">
            <BirthdayField birthDate={''} setBirthdate={bday => this.setBirthday(bday, 'child', Number(i))} />
          </div>
          {dentalIn[i].haveGender && (
            <GenderField
              applicant="child"
              index={i}
              setGender={(e, applicant, index) => this.handleGenderChange(e, applicant, index)}
            />
          )}
        </div>
        <div className="dental-repeater-item-bottom clearfix">
          {dentalIn[i].haveSmoker && (
            <UserMetaField
              applicant="children"
              fieldKey="isSmoker"
              handleCheckBoxFields={e => this.handleCheckBoxFields(e, 'children', 'isSmoker')}
              id="children_is_smoker"
              index={Number(i)}
              label="Is Smoker"
            />
          )}
          {dentalIn[i].haveStudent && (
            <UserMetaField
              applicant="children"
              fieldKey="isStudent"
              handleCheckBoxFields={e => this.handleCheckBoxFields(e, 'children', 'isStudent')}
              id="children_is_student"
              index={Number(i)}
              label="Is Student"
            />
          )}
          {dentalIn[i].haveDisabled && (
            <UserMetaField
              applicant="children"
              fieldKey="isDisabled"
              handleCheckBoxFields={e => this.handleCheckBoxFields(e, 'children', 'isDisabled')}
              id="children_is_disabled"
              index={Number(i)}
              label="Is Disabled"
            />
          )}
        </div>
      </div>
    ));
  }

  showResult() {
    if (Object.keys(this.state.plansList).length > 0) {
      return <InsurancePlans plans={this.state.plansList} quoteRequestId={this.state.quoteRequestId} />;
    }
    return <></>;
  }

  render() {
    return (
      <DentalInsuranceLeadFunnelWrapper>
        <div className="bz3-insurance-form form lead-form template-mortgage-funnel">
          <div className="dental-insurance-com-lead-form-container" id="mortgage-lead-funnel">
            <div className="dental-insurance-options">
              <div className="mortgage-lead-funnel-wrapper inline-dental-insurance">
                <div className="dental-family-member">
                  <form onSubmit={e => this.submitDentalApplication(e)}>
                    {this.mainApplicant()}
                    {this.state.addSpouse && this.spouseApplicant()}
                    {this.createUI()}

                    <div className="flex justify-end clearfix mb-4">
                      {!this.state.addSpouse && (
                        <Button className="mr-2" onClick={e => this.addSpouse(e)} size="sm" variant="primary">
                          Add Spouse
                        </Button>
                      )}
                      <Button onClick={e => this.addChild(e)} size="sm" variant="primary">
                        Add Child
                      </Button>
                    </div>
                    <div className="error">
                      {this.state.error && <div className="error">{this.state.error.join('<br>')}</div>}
                    </div>
                    <div className="input-group-action">
                      <input className="button submit-btn" type="submit" value="Get Quotes" />
                    </div>
                  </form>
                </div>
              </div>
              <div>{Object.keys(this.state.plansList).length > 0 && this.showResult()}</div>
            </div>
          </div>
        </div>
      </DentalInsuranceLeadFunnelWrapper>
    );
  }
}

const DentalInsuranceLeadFunnelWrapper = styled.div`
  .bz3-insurance-form {
    input[type='date'] {
      position: relative;
    }
    .inline-dental-insurance {
      .input-group {
        margin-bottom: 10px !important;
      }
    }
    .dental-repeater-item {
      display: inline-block;
      width: 50%;
      float: left;
      .bz-date-picker {
        width: 100%;
        height: 100%;
      }
    }
    .dental-repeater-item-top {
      display: flex;
      flex-wrap: wrap;
    }
    .dental-repeater-item {
      &.even {
        padding-left: 2%;
      }
      &.odd {
        padding-right: 2%;
      }
    }
    &.form.lead-form {
      input[type='date'].input-group {
        font-size: 1em;
        padding-top: 6px;
        padding-bottom: 6px;
      }
      .dental-family-member {
        label {
          margin-bottom: 3px;
          font-size: 11px;
          margin-bottom: 0.5em;
          text-transform: uppercase;
          font-style: inherit;
          color: #0a0a0a;
        }
      }
      label:first-child {
        border-radius: 8px 0 0 8px;
      }
      label:last-child {
        border-radius: 0 8px 8px 0;
        border-left: 0;
      }
      h6.dental-insu-heading {
        font-style: normal;
        color: #002d45;
      }
      h6.field-label {
        font-size: 11px;
        margin-bottom: 0.5em;
        text-transform: uppercase;
        font-style: inherit;
        color: #0a0a0a;
      }
      .member-details-table-nav {
        h6 {
          margin: 0;
          color: #fff;
          font-style: normal;
        }
      }
    }
    .input-group-action {
      .button {
        color: #ffffff;
        border: solid 1px #ff5a1f;
        background: #ff5a1f;
        width: 100%;
        display: inherit;
        height: 56px;
        padding: 1rem 2.5rem;
        font-weight: 700;
        font-size: 1rem;
        line-height: 1.25rem;
      }
    }
    .btn-group {
      display: inline-block;
      label {
        display: inline-block;
        background-color: #efefef;
        float: left;
        margin-bottom: 0;
        padding: 4px 8px;
        border: 1px solid #ddd;
        font-size: 0.6em;
        cursor: pointer;
        input.btn-radio {
          margin-bottom: 0;
          position: relative;
          top: 2px;
          margin-right: 3px;
        }
      }
    }

    .dental-repeater-wrapper {
      background-color: #f7f7f7;
      padding: 10px;
      border-radius: 3px;
      border: 1px solid #ddd;
      margin-bottom: 10px;
      position: relative;
      .dental-family-remove {
        position: absolute;
        right: 10px;
        cursor: pointer;
        color: #bf0c0c;
        top: 5px;
      }
    }
    .dental-repeater-item-bottom {
      .dental-repeater-item {
        float: none;
        width: auto;
        margin-right: 15px;
        label:last-child {
          border-left: 1px solid #ddd;
          border-radius: 8px;
        }
      }
    }
    .dental-family-action {
      text-align: right;
      margin-top: 10px;
    }
    .member-details-item {
      font-size: 0.8em;
    }
    .member-details-item {
      .member-detail-heading {
        font-size: 1.1em;
      }
      .member-details-action {
        height: auto;
        min-height: auto;
        line-height: 30px;
        margin-bottom: 3px;
      }
      .bz3-plan-data-more-link {
        font-size: 12px;
      }
    }
    .dental-insurance-options {
      position: relative;
      .loading-icon {
        position: absolute;
        background: rgba(255, 255, 255, 0.8);
        height: 100%;
        top: 0;
        bottom: 0;
        z-index: 10;
      }
      .fa-spinner.fa-spin {
        position: absolute;
        top: 40%;
      }
    }
    .bz3-plan-data-row {
      border-bottom: solid 1px #ddd;
      &:hover {
        background: #f5f5f5;
      }
      &:nth-child(even) {
        background-color: #f1f1f1 !important;
      }
      .bz3-plan-data-row__highlight {
        padding: 10px 8px;
      }
    }
    .member-plan-price {
      font-size: 1rem;
      font-weight: 600;
      padding-left: 5px;
      padding-right: 5px;
    }
    .plan-action-cell {
      text-align: center;
    }
    .member-details-table-nav {
      background-color: #002d45;
      margin: 0;
      list-style: none;
      padding: 0;
      li {
        padding: 8px 10px;
      }
    }
    .plan-more-details-wrapper {
      border-top: solid 1px #ddd;
      ul {
        list-style: none;
        margin: 10px 0 15px;
        li {
          padding: 5px 0;
          border-bottom: 1px solid #ddd;
        }
        &.plan-remove-border-top {
          border-bottom: 0;
        }
      }
    }
  }

  @media only screen and (max-width: 1023px) {
    .bz3-insurance-form {
      .dental-repeater-item {
        width: 100%;
        &.odd {
          padding-right: 0;
        }
        &.even {
          padding-left: 0;
        }
      }
    }
  }
  @media only screen and (min-width: 991px) {
    .plan-more-details-wrapper {
      ul {
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
      }
    }
  }

  .bz3-insurance-form,
  .bz3-form,
  .quote-form {
    .input-group {
      overflow: hidden;
      border: solid 1px #ccc;
      border-radius: 2px;
      input.input-group-field {
        margin-bottom: 0;
        border: none;
        height: 30px;
        width: 100%;
      }
      .button {
        transform: translateY(0px);
        &:hover {
          transform: translateY(0px);
        }
      }
    }
  }

  .bz3-insurance-form.lead-form {
    border-radius: 8px;
    background-color: #fff;
    box-shadow: 0 0 6px 1px hsla(0, 0%, 63.9%, 0.24);
    transition: all 300ms ease;
    margin-bottom: 24px;
    color: #4c5159;
    border: 1px solid #d6d6d6;
    padding: 1rem;
    margin: 0 auto 1rem auto;
    max-width: 500px;

    &:hover {
      box-shadow: 0 0 7px 2px hsla(0, 0%, 63.9%, 0.5);
    }

    &.active {
      width: 100%;
    }

    .input-group {
      margin-bottom: 0;
      border-radius: 4px;
      overflow: hidden;
      input {
        border-radius: 0;
        box-shadow: none;
        padding: 8px;
      }
    }
  }

  .clearfix:after,
  .clearfix:before {
    display: table;
    content: ' ';
    -ms-flex-preferred-size: 0;
    flex-basis: 0;
    -webkit-box-ordinal-group: 2;
    -ms-flex-order: 1;
    order: 1;
  }
  .clearfix:after {
    clear: both;
  }
  .error {
    color: red;
    font-size: 13px;
  }
`;
